import { cn } from '../../lib/cn';

interface SpinnerProps {
  className?: string;
  label?: string;
}

export function Spinner({ className, label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label ?? 'Yükleniyor'}
      className={cn(
        'inline-block animate-spin rounded-full border-2 border-current border-t-transparent',
        // prefers-reduced-motion: dönme yerine sabit bir gösterge
        'motion-reduce:animate-none motion-reduce:border-t-current motion-reduce:opacity-60',
        'h-4 w-4',
        className,
      )}
    />
  );
}

/**
 * İçerik yüklenirken yer tutucu — CLS (layout shift) yaratmaz.
 *
 * İskeletin işi "bir şey yükleniyor" demek değil, GELECEK OLANIN ŞEKLİNİ
 * göstermektir. Önceki hâli gerçek kartla uyuşmuyordu: altta tam genişlikte
 * bir buton bloğu vardı ama karttaki buton sağa hizalı ve dar; içerik gelince
 * düzen gözle görülür biçimde zıplıyordu. Bu blok artık `GroupSessionCard`
 * anatomisini izliyor (rozet satırı · başlık · meta · eğitmen · alt bilgi).
 */
export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div
      aria-hidden
      /* Yükleme durumu TESTLERCE gözlemlenebilir olmalı.
         E2E paketi "buton göründü" anını hazır sayıyordu, ama o an geçiş
         ortası olabiliyor: sorgu oturunca ızgara iskeletten karta takas
         ediliyor ve yakalanan element bayatlıyordu. Testin bekleyeceği
         kesin bir sinyal olmadan bu yarış kapanmıyor. */
      data-testid="skeleton-card"
      className={cn(
        'animate-pulse rounded-sharp border border-line bg-surface p-5 motion-reduce:animate-none',
        className,
      )}
    >
      <div className="flex items-center justify-between">
        <div className="h-5 w-28 rounded-sharp bg-sunken" />
        <div className="h-5 w-20 rounded-sharp bg-sunken" />
      </div>

      <div className="mt-3 h-6 w-4/5 rounded-sharp bg-sunken" />
      <div className="mt-2 h-3.5 w-3/5 rounded-sharp bg-sunken" />

      <div className="mt-4 space-y-2">
        <div className="h-3.5 w-32 rounded-sharp bg-sunken" />
        <div className="h-3.5 w-24 rounded-sharp bg-sunken" />
      </div>

      <div className="mt-4 flex items-center gap-2.5">
        <div className="h-8 w-8 rounded-full bg-sunken" />
        <div className="h-3.5 w-36 rounded-sharp bg-sunken" />
      </div>

      <div className="mt-5 flex items-center justify-between border-t border-line pt-4">
        <div className="h-3 w-24 rounded-sharp bg-sunken" />
        <div className="h-11 w-20 rounded-sharp bg-sunken" />
      </div>
    </div>
  );
}
